import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const LeftColumn = styled(FlexColumn)`
  flex-shrink: 0;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;

  padding: 48px;

  ${QUERIES.largeTabletAndUp} {
    width: 410px;
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const CompactHeader = styled(FlexRow)`
  position: absolute;
  top: 0;
  left: 0;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 64px;
  box-shadow: ${themeStyle.varShadowSmallHeavy};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 14px 10px 10px;
`;
